<new-ui-selectbutton
  [formControl]="$any(formControl)"
  [formlyAttributes]="field"
  [label]="props.label"
  [options]="props.options | formlySelectOptions: field | async"
  [optionLabel]="props.optionLabel ?? 'label'"
  [optionValue]="props.optionValue ?? 'value'"
  [allowEmpty]="props.allowEmpty ?? true"
  [multiple]="props.multiple ?? false"
  [required]="props.required"
  [readonly]="props.readonly"
  (changed)="props.change && props.change(field, $event)"
/>

@if (showError) {
  <p-message severity="error" variant="simple" size="small">
    <formly-validation-message [field]="field" />
  </p-message>
}
